import {noop} from '@benchling/js-utils';
import React, {useState, useEffect} from 'react';
import * as uuid from 'uuid';

import ProcessFlowchartEditor, {ProcessFlowchartEditorProps} from './ProcessFlowchartEditor';

type ProcessFlowchartViewerProps = Pick<
  ProcessFlowchartEditorProps,
  | 'flowchart'
  | 'designSpace'
  | 'reactFlowEmbeddedElement'
  | 'editorEventGroupId'
  | 'actionMethod'
  | 'didInitialFlowchartHaveChainedRouters'
>;

export default function ProcessFlowchartViewer(props: ProcessFlowchartViewerProps): JSX.Element {
  const [flowchartEditorKey, setFlowchartEditorKey] = useState(uuid.v4());

  useEffect(
    () => {
      setFlowchartEditorKey(uuid.v4());
    },
    // Both flowchart and designSpace are used to validate the graph, so changes to either should recreate
    // the flowchart viewer
    [props.flowchart, props.designSpace]
  );

  return (
    <ProcessFlowchartEditor
      {...props}
      key={flowchartEditorKey}
      locked={true}
      hideSidebar={true}
      onFlowchartChange={noop}
      editorEventGroupId={props.editorEventGroupId}
      actionMethod={props.actionMethod}
      didInitialFlowchartHaveChainedRouters={props.didInitialFlowchartHaveChainedRouters}
    />
  );
}
